import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "kn-relative p-d-flex p-flex-row kn-height-full kn-width-full"
}
const _hoisted_3 = { class: "p-d-flex p-flex-column kn-flex kn-overflow-hidden" }
const _hoisted_4 = { class: "kn-flex kn-overflow-hidden" }
const _hoisted_5 = { class: "kn-flex kn-overflow-hidden" }
const _hoisted_6 = {
  key: 2,
  class: "qbe-detail-view p-m-1"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 2,
  class: "fa-stack p-mx-2"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ban fa-stack-2x" }, null, -1)
const _hoisted_10 = { class: "kn-relative kn-flex p-mt-2" }
const _hoisted_11 = { class: "kn-height-full kn-width-full kn-absolute" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_14 = {
  key: 0,
  class: "p-field p-col-3"
}
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_17 = { class: "p-float-label" }
const _hoisted_18 = {
  for: "columnType",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Chip = _resolveComponent("Chip")
  const _component_ExpandableEntity = _resolveComponent("ExpandableEntity")
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")
  const _component_SubqueryEntity = _resolveComponent("SubqueryEntity")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_QBESimpleTable = _resolveComponent("QBESimpleTable")
  const _component_QBESmartTable = _resolveComponent("QBESmartTable")
  const _component_KnParameterSidebar = _resolveComponent("KnParameterSidebar")
  const _component_QBEPreviewDialog = _resolveComponent("QBEPreviewDialog")
  const _component_QBEFilterDialog = _resolveComponent("QBEFilterDialog")
  const _component_QBESqlDialog = _resolveComponent("QBESqlDialog")
  const _component_QBERelationDialog = _resolveComponent("QBERelationDialog")
  const _component_QBEParamDialog = _resolveComponent("QBEParamDialog")
  const _component_QBEHavingDialog = _resolveComponent("QBEHavingDialog")
  const _component_QBEAdvancedFilterDialog = _resolveComponent("QBEAdvancedFilterDialog")
  const _component_QBESavingDialog = _resolveComponent("QBESavingDialog")
  const _component_QBEJoinDefinitionDialog = _resolveComponent("QBEJoinDefinitionDialog")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnCalculatedField = _resolveComponent("KnCalculatedField")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "full-screen-dialog",
    visible: true,
    modal: false,
    closable: false,
    position: "right",
    baseZIndex: 1,
    autoZIndex: true,
    onClick: _ctx.closeMainMenu
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12" }, {
        start: _withCtx(() => [
          (_ctx.qbe)
            ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.qbe.label ? _ctx.qbe.label : _ctx.qbe.qbeDatamarts), 1))
            : _createCommentVNode("", true)
        ]),
        end: _withCtx(() => [
          (_ctx.isParameterSidebarVisible)
            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "pi pi-filter",
                class: "p-button-text p-button-rounded p-button-plain",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.parameterSidebarVisible = !_ctx.parameterSidebarVisible))
              }, null, 512)), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.filter'),
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-save",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _ctx.openSavingDialog
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('common.save'),
              void 0,
              { bottom: true }
            ]
          ]),
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          }, null, 512), [
            [
              _directive_tooltip,
              _ctx.$t('common.close'),
              void 0,
              { bottom: true }
            ]
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
            key: 0,
            class: "kn-progress-spinner"
          }))
        : _createCommentVNode("", true),
      (!_ctx.qbePreviewDialogVisible)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_ctx.parameterSidebarVisible)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  style: _ctx.qbeDescriptor.style.backdrop,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.parameterSidebarVisible = false))
                }, null, 4))
              : _createCommentVNode("", true),
            (_ctx.showEntitiesLists && _ctx.qbeLoaded)
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  style: _ctx.qbeDescriptor.style.entitiesLists
                }, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary kn-flex-0" }, {
                      start: _withCtx(() => [
                        _createVNode("span", null, _toDisplayString(_ctx.$t("qbe.entities.title")), 1)
                      ]),
                      end: _withCtx(() => [
                        _createVNode(_component_Chip, { style: {"background-color":"white"} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.entities?.entities?.length), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode("div", _hoisted_4, [
                      _createVNode(_component_ScrollPanel, { class: "kn-height-full qbe-scroll-panel" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ExpandableEntity, {
                            availableEntities: _ctx.entities.entities,
                            query: _ctx.mainQuery,
                            onShowRelationDialog: _ctx.showRelationDialog,
                            onEntityClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDropComplete($event, false))),
                            onEntityChildClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDropComplete($event, false))),
                            onOpenFilterDialog: _ctx.openFilterDialog
                          }, null, 8, ["availableEntities", "query", "onShowRelationDialog", "onOpenFilterDialog"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode("div", {
                    class: ["p-d-flex p-flex-column kn-overflow-hidden", { 'derived-entities-toggle': _ctx.showDerivedList }]
                  }, [
                    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary kn-flex-0" }, {
                      start: _withCtx(() => [
                        _createVNode("span", null, _toDisplayString(_ctx.$t("qbe.entities.derived")), 1)
                      ]),
                      end: _withCtx(() => [
                        (_ctx.showEntitiesLists)
                          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              icon: "fas fa-plus-circle",
                              class: "p-button-text p-button-rounded p-button-plain",
                              onClick: _ctx.createSubquery
                            }, null, 8, ["onClick"])), [
                              [
                                _directive_tooltip,
                                _ctx.$t('common.add'),
                                void 0,
                                { top: true }
                              ]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode(_component_Chip, { style: {"background-color":"white"} }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.mainQuery?.subqueries?.length), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.showDerivedList)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              icon: "pi pi-chevron-down",
                              class: "p-button-text p-button-rounded p-button-plain",
                              onClick: _ctx.collapseDerivedList
                            }, null, 8, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_Button, {
                              key: 2,
                              icon: "pi pi-chevron-up",
                              class: "p-button-text p-button-rounded p-button-plain",
                              onClick: _ctx.collapseDerivedList
                            }, null, 8, ["onClick"]))
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode("div", _hoisted_5, [
                      _createVNode(_component_ScrollPanel, { class: "kn-height-full qbe-scroll-panel" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SubqueryEntity, {
                            availableEntities: _ctx.mainQuery?.subqueries,
                            onEditSubquery: _ctx.selectSubquery,
                            onDeleteSubquery: _ctx.deleteSubquery
                          }, null, 8, ["availableEntities", "onEditSubquery", "onDeleteSubquery"])
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, _ctx.showDerivedList]
                    ])
                  ], 2)
                ], 4))
              : _createCommentVNode("", true),
            (_ctx.qbe && _ctx.qbeLoaded)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary kn-width-full" }, {
                    start: _withCtx(() => [
                      (_ctx.showEntitiesLists)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "pi pi-chevron-left",
                            class: "p-button-text p-button-rounded p-button-plain",
                            onClick: _ctx.toggleEntitiesLists
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('qbe.detailView.hideList'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            icon: "pi pi-chevron-right",
                            class: "p-button-text p-button-rounded p-button-plain",
                            onClick: _ctx.toggleEntitiesLists
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('qbe.detailView.showList'),
                              void 0,
                              { bottom: true }
                            ]
                          ]),
                      (_ctx.selectedQuery.id !== 'q1')
                        ? (_openBlock(), _createBlock("span", _hoisted_7, [
                            _createVNode(_component_Button, {
                              label: "MAIN",
                              class: "p-button-text p-button-plain kn-uppercase",
                              onClick: _ctx.selectMainQuery
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_Button, {
                              icon: "pi pi-chevron-right",
                              class: "p-button-text p-button-plain"
                            }),
                            _createVNode(_component_Button, {
                              label: _ctx.selectedQuery?.name,
                              class: "p-button-text p-button-plain kn-uppercase"
                            }, null, 8, ["label"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    end: _withCtx(() => [
                      (_ctx.selectedQuery?.fields?.length > 0)
                        ? _withDirectives((_openBlock(), _createBlock("i", {
                            key: 0,
                            class: "fas fa-eraser kn-cursor-pointer p-mx-2",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteAllFieldsFromQuery && _ctx.deleteAllFieldsFromQuery(...args)))
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              _ctx.$t('qbe.viewToolbar.deleteAllSelectedFields'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.hiddenColumnsExist)
                        ? _withDirectives((_openBlock(), _createBlock("i", {
                            key: 1,
                            class: "pi pi-eye kn-cursor-pointer p-mx-2",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showHiddenColumns && _ctx.showHiddenColumns(...args)))
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              _ctx.$t('qbe.viewToolbar.showHiddenColumns'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.selectedQuery?.filters?.length > 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_8, [
                            _hoisted_9,
                            _withDirectives(_createVNode("i", {
                              class: "fas fa-filter fa-stack-1x kn-cursor-pointer",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.deleteAllFilters && _ctx.deleteAllFilters(...args)))
                            }, null, 512), [
                              [
                                _directive_tooltip,
                                _ctx.$t('qbe.viewToolbar.deleteAllFilters'),
                                void 0,
                                { top: true }
                              ]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_InputSwitch, {
                        class: "p-mr-2",
                        modelValue: _ctx.smartView,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.smartView = $event)),
                        onChange: _ctx.updateSmartView
                      }, null, 8, ["modelValue", "onChange"]),
                      _createVNode("span", null, _toDisplayString(_ctx.$t("qbe.viewToolbar.smartView")), 1),
                      _withDirectives(_createVNode("i", {
                        class: "fas fa-play p-m-2 kn-cursor-pointer",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openPreviewDialog && _ctx.openPreviewDialog(...args)))
                      }, null, 512), [
                        [_vShow, !_ctx.smartView]
                      ]),
                      _createVNode(_component_Button, {
                        icon: "fas fa-ellipsis-v kn-cursor-pointer",
                        class: "p-button-text p-button-rounded p-button-plain",
                        onClick: _ctx.showMenu
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      (!_ctx.smartView)
                        ? (_openBlock(), _createBlock(_component_QBESimpleTable, {
                            key: 0,
                            query: _ctx.selectedQuery,
                            onColumnVisibilityChanged: _ctx.checkIfHiddenColumnsExist,
                            onOpenFilterDialog: _ctx.openFilterDialog,
                            onOpenHavingDialog: _ctx.openHavingDialog,
                            onEntityDropped: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onDropComplete($event, false))),
                            onGroupingChanged: _ctx.onGroupingChanged,
                            onOpenCalculatedFieldDialog: _ctx.editCalcField,
                            onFieldDeleted: _ctx.onFieldDeleted,
                            onFieldAliasChanged: _ctx.onFieldAliasChange
                          }, null, 8, ["query", "onColumnVisibilityChanged", "onOpenFilterDialog", "onOpenHavingDialog", "onGroupingChanged", "onOpenCalculatedFieldDialog", "onFieldDeleted", "onFieldAliasChanged"]))
                        : (_openBlock(), _createBlock(_component_QBESmartTable, {
                            key: 1,
                            query: _ctx.selectedQuery,
                            previewData: _ctx.queryPreviewData,
                            pagination: _ctx.pagination,
                            onRemoveFieldFromQuery: _ctx.deleteFieldFromQuery,
                            onOrderChanged: _ctx.updateSmartView,
                            onFieldHidden: _ctx.smartViewFieldHidden,
                            onFieldGrouped: _ctx.updateSmartView,
                            onFieldAggregated: _ctx.updateSmartView,
                            onAliasChanged: _ctx.onFieldAliasChange,
                            onReordered: _ctx.smartViewReorder,
                            onEntityDropped: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onDropComplete($event, false))),
                            onPageChanged: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updatePagination($event))),
                            onOpenFilterDialog: _ctx.openFilterDialog
                          }, null, 8, ["query", "previewData", "pagination", "onRemoveFieldFromQuery", "onOrderChanged", "onFieldHidden", "onFieldGrouped", "onFieldAggregated", "onAliasChanged", "onReordered", "onOpenFilterDialog"]))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.parameterSidebarVisible)
              ? (_openBlock(), _createBlock(_component_KnParameterSidebar, {
                  key: 3,
                  filtersData: _ctx.filtersData,
                  propDocument: _ctx.dataset || _ctx.sourceDataset,
                  userRole: _ctx.userRole,
                  propMode: 'qbeView',
                  propQBEParameters: _ctx.qbe?.pars,
                  onExecute: _ctx.onExecute,
                  onRoleChanged: _ctx.onRoleChange
                }, null, 8, ["filtersData", "propDocument", "userRole", "propQBEParameters", "onExecute", "onRoleChanged"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_QBEPreviewDialog, {
        id: _ctx.uniqueID,
        queryPreviewData: _ctx.queryPreviewData,
        pagination: _ctx.pagination,
        entities: _ctx.entities?.entities,
        selectedQuery: _ctx.selectedQuery,
        onClose: _ctx.closePreview,
        onPageChanged: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updatePagination($event)))
      }, null, 8, ["id", "queryPreviewData", "pagination", "entities", "selectedQuery", "onClose"]), [
        [_vShow, !_ctx.loading && _ctx.qbePreviewDialogVisible]
      ]),
      _createVNode(_component_QBEFilterDialog, {
        visible: _ctx.filterDialogVisible,
        filterDialogData: _ctx.filterDialogData,
        id: _ctx.uniqueID,
        entities: _ctx.entities?.entities,
        propParameters: _ctx.qbe?.pars,
        propExpression: _ctx.selectedQuery?.expression,
        onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.filterDialogVisible = false)),
        onSave: _ctx.onFiltersSave
      }, null, 8, ["visible", "filterDialogData", "id", "entities", "propParameters", "propExpression", "onSave"]),
      _createVNode(_component_QBESqlDialog, {
        visible: _ctx.sqlDialogVisible,
        sqlData: _ctx.sqlData,
        onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sqlDialogVisible = false))
      }, null, 8, ["visible", "sqlData"]),
      _createVNode(_component_QBERelationDialog, {
        visible: _ctx.relationDialogVisible,
        propEntity: _ctx.relationEntity,
        onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.relationDialogVisible = false))
      }, null, 8, ["visible", "propEntity"]),
      (_ctx.paramDialogVisible)
        ? (_openBlock(), _createBlock(_component_QBEParamDialog, {
            key: 2,
            visible: _ctx.paramDialogVisible,
            propDataset: _ctx.qbe,
            onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.paramDialogVisible = false)),
            onSave: _ctx.onParametersSave
          }, null, 8, ["visible", "propDataset", "onSave"]))
        : _createCommentVNode("", true),
      _createVNode(_component_QBEHavingDialog, {
        visible: _ctx.havingDialogVisible,
        havingDialogData: _ctx.havingDialogData,
        entities: _ctx.selectedQuery?.fields,
        onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.havingDialogVisible = false)),
        onSave: _ctx.onHavingsSave
      }, null, 8, ["visible", "havingDialogData", "entities", "onSave"]),
      _createVNode(_component_QBEAdvancedFilterDialog, {
        visible: _ctx.advancedFilterDialogVisible,
        query: _ctx.selectedQuery,
        onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.advancedFilterDialogVisible = false)),
        onSave: _ctx.onAdvancedFiltersSave
      }, null, 8, ["visible", "query", "onSave"]),
      _createVNode(_component_QBESavingDialog, {
        visible: _ctx.savingDialogVisible,
        propDataset: _ctx.qbe,
        propMetadata: _ctx.qbeMetadata,
        onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.savingDialogVisible = false)),
        onDatasetSaved: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('datasetSaved')))
      }, null, 8, ["visible", "propDataset", "propMetadata"]),
      (_ctx.joinDefinitionDialogVisible)
        ? (_openBlock(), _createBlock(_component_QBEJoinDefinitionDialog, {
            key: 3,
            visible: _ctx.joinDefinitionDialogVisible,
            qbe: _ctx.qbe,
            propEntities: _ctx.entities?.entities,
            id: _ctx.uniqueID,
            selectedQuery: _ctx.selectedQuery,
            onClose: _ctx.onJoinDefinitionDialogClose
          }, null, 8, ["visible", "qbe", "propEntities", "id", "selectedQuery", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.calcFieldDialogVisible)
        ? (_openBlock(), _createBlock(_component_KnCalculatedField, {
            key: 4,
            template: _ctx.selectedCalcField,
            "onUpdate:template": _cache[26] || (_cache[26] = ($event: any) => (_ctx.selectedCalcField = $event)),
            visibility: _ctx.calcFieldDialogVisible,
            "onUpdate:visibility": _cache[27] || (_cache[27] = ($event: any) => (_ctx.calcFieldDialogVisible = $event)),
            fields: _ctx.calcFieldColumns,
            descriptor: _ctx.calcFieldDescriptor,
            propCalcFieldFunctions: _ctx.calcFieldFunctionsToShow,
            readOnly: false,
            valid: true,
            source: "QBE",
            onSave: _ctx.onCalcFieldSave,
            onCancel: _cache[28] || (_cache[28] = ($event: any) => (_ctx.calcFieldDialogVisible = false))
          }, {
            additionalInputs: _withCtx(() => [
              _createVNode("div", {
                class: ["p-field", [_ctx.selectedCalcField.type === 'DATE' ? 'p-col-3' : 'p-col-4']]
              }, [
                _createVNode("span", _hoisted_12, [
                  _createVNode(_component_Dropdown, {
                    id: "type",
                    class: "kn-material-input",
                    modelValue: _ctx.selectedCalcField.type,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.selectedCalcField.type = $event)),
                    options: _ctx.qbeDescriptor.types,
                    optionLabel: "label",
                    optionValue: "name"
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("components.knCalculatedField.type")), 1)
                ])
              ], 2),
              (_ctx.selectedCalcField.type === 'DATE')
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _createVNode("span", _hoisted_15, [
                      _createVNode(_component_Dropdown, {
                        id: "type",
                        class: "kn-material-input",
                        modelValue: _ctx.selectedCalcField.format,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.selectedCalcField.format = $event)),
                        options: _ctx.qbeDescriptor.admissibleDateFormats
                      }, {
                        value: _withCtx(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.selectedCalcField.format ? _ctx.moment().format(_ctx.selectedCalcField.format) : ""), 1)
                        ]),
                        option: _withCtx((slotProps) => [
                          _createVNode("span", null, _toDisplayString(_ctx.moment().format(slotProps.option)), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options"]),
                      _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("managers.datasetManagement.ckanDateFormat")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", {
                class: ["p-field", [_ctx.selectedCalcField.type === 'DATE' ? 'p-col-3' : 'p-col-4']]
              }, [
                _createVNode("span", _hoisted_17, [
                  _createVNode(_component_Dropdown, {
                    id: "columnType",
                    class: "kn-material-input",
                    modelValue: _ctx.selectedCalcField.nature,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.selectedCalcField.nature = $event)),
                    options: _ctx.qbeDescriptor.columnTypes,
                    optionLabel: "label",
                    optionValue: "name"
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("managers.functionsCatalog.columnType")), 1)
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["template", "visibility", "fields", "descriptor", "propCalcFieldFunctions", "onSave"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Menu, {
        id: "optionsMenu",
        ref: "optionsMenu",
        model: _ctx.menuButtons
      }, null, 8, ["model"])
    ]),
    _: 1
  }, 8, ["onClick"]))
}